import React, { useState, useRef, useContext } from "react";

import { Card, Col, Row } from "react-bootstrap"

import { useTranslation } from "react-i18next";

import { __SystemBulkUpload, __MessageTypes, __enum_TeachBulkUpload, enum__BULK_PAYLOAD_TYPE_ID, __BULK_PAYLOAD_TYPE_ID, enum__AppElementType } from "../common/Dictionaries";

import { ActionButton, DirectionalHint, SpinnerSize, Dropdown, TooltipHost } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';

import { getGridLocalization, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from "../common/Helpers";
import MessageBox from "../components/Common/Message/MessageBox";
import MainAppContext from "../MainAppContext";
import { getBookPayload, getKPIPayload, getPartidaPayload, postValidateBookDocument, postValidateKPIDocument, postValidatePartidaDocument } from "../services/Bulk/bulk.service";
import { TeachBubbleMultiSteps } from "../components/Templates/TeachBubble/indexMultiSteps";
import moment from "moment";
import { addTransversalDocument } from "../services/sBook/document.service";
import Loading from "../components/Templates/Site/Loading";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
import CLabel from "../components/Common/CLabel";
import { useGetBulkContractPartieElements, useGetContractByElementId } from "../hooks/services/sKPI/useOfBoard";
import IndexHeaderBulkpUpload from "../components/Products/sPay/PayContractInfo/indexBulk";
import AuthVerify from "../components/Templates/Site/AuthVerify";
import { useSelector } from "react-redux";
import { envBlobDocumentUpload, envDocumentGetUrl, envDocumentValidate } from "../services/Env/transversal.service";
import { FILE_MAX_SIZE } from "../configurations/application.config";

export default function BulkUpload(props) {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const { token: currentAuth } = useSelector((state) => state.auth);

    const queryStringElementId = props.match.params.elementId !== null && props.match.params.elementId !== undefined && props.match.params.elementId !== "" ? props.match.params.elementId : null;

    const inputParam_EditMode = props.editMode !== null && props.editMode !== undefined ? props.editMode : true;
    
    const profileHasAccess = (!contextSite.onlyObserver && inputParam_EditMode) || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)
    
    const inputParam_ShowSelection = props.inputParam_ShowSelection !== null && props.inputParam_ShowSelection !== undefined ? props.inputParam_ShowSelection : false;

    const listBulkTemplates = __SystemBulkUpload
        .filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase()))
        .filter(x => isNullUndefinedOrEmpty(queryStringElementId)? x.enabledOnlyWithElementIdAvailable === false : true).filter(x => x.disable === false).map(x => {
            x.name = t(x.name);
            x.description = t(x.description);

        return x;
    });

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const gridRef = useRef();
    const fileInputRef = useRef(null);
    const [uploadInProgress, setUploadInProgress] = useState(false);
    const [selectedTemplateType, setSelectedTemplateType] = useState(-1);
    
    const [contract, setContract] = useState(null);

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileUploaded, setFileUploaded] = useState(false);
    const [documentId, setDocumentId] = useState(null);
    const [processedFile, setProcessedFile] = useState(null);
    
    useGetContractByElementId(queryStringElementId, contract, setContract)
    
    const handlerExportTemplate = async () => {
        const elementList = queryStringElementId != null ? [parseInt(queryStringElementId)] : [];
        const periodId = 0;

        if (selectedTemplateType !== -1) {
            if (selectedTemplateType === enum__BULK_PAYLOAD_TYPE_ID.PARTIES ? (queryStringElementId !== null) : true) {

                const bulkGetTemplateService = getDownloadTemplateServiceEvent(selectedTemplateType);

                if (bulkGetTemplateService !== null) {

                    if (selectedTemplateType === enum__BULK_PAYLOAD_TYPE_ID.PARTIES && isNullUndefinedOrEmpty(queryStringElementId)) {
                        elementList.push(queryStringElementId);
                    }

                    await bulkGetTemplateService(elementList, periodId).then(async (serviceResponse) => {
                        if (serviceResponse.data.length > 0) {
                            const response = serviceResponse.data;
            
                            response.forEach(file => {
                                const byteCharacters = atob(file);
                                const byteNumbers = new Array(byteCharacters.length);
                                for (let i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                const byteArray = new Uint8Array(byteNumbers);
                                const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                        
                                const link = document.createElement('a');
                                link.href = URL.createObjectURL(blob);
                                link.download = `Payload ${selectedTemplateType === enum__BULK_PAYLOAD_TYPE_ID.PARTIES ? "Partidas" : (selectedTemplateType === enum__BULK_PAYLOAD_TYPE_ID.BOOK ? "BOOK" : "KPI") } ${moment().format("YYYYMMDD")}.xlsx`;
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                            });
                            setProcessedFile(null);
                            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                        }
                    }).catch(() => {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    });
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                }
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectcontract'))
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selecttemplate'))
        }
    };

    const handlerSelectFile = () => {
        fileInputRef.current.click();
    };

    const handleFileInput = (event) => {
        // handle validations
        const file = !isNullUndefined(event.target) ? event.target.files[0] : event;
        let flag = false;
        
        if (file) {
            const maxSizeInMB = FILE_MAX_SIZE;
            const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

            if (file.size > maxSizeInBytes) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))    

                setSelectedFile(file);
                setProcessedFile(null);
            }
            else {
                if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                    setSelectedFile(file);
                    setProcessedFile(null);
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror-1')) 
                }
                else {
                    flag = true;
                    setSelectedFile(file);
                    setProcessedFile(null);
                    showMessage(setMessageConfig, false, __MessageTypes.WARNING, '')  
                }
            }
        }

        return flag;
    };

    const getDownloadTemplateServiceEvent = (payloadId) => {
        switch (payloadId) {
            case enum__BULK_PAYLOAD_TYPE_ID.KPI:
                return getKPIPayload;
            case enum__BULK_PAYLOAD_TYPE_ID.PARTIES:
                return getPartidaPayload;
            case enum__BULK_PAYLOAD_TYPE_ID.BOOK:
                return getBookPayload;
            default:
                return null
        }
    }

    const handlerUploadFile = async () => {
        //const formData = new FormData();
        //formData.append('file', selectedFile);
        //formData.append("id", selectedTemplateType);
        //formData.append("url", 'Bulk/uploadPayload/nuevo');
        if (selectedTemplateType !== -1) {
            if (selectedTemplateType === enum__BULK_PAYLOAD_TYPE_ID.PARTIES ? (queryStringElementId !== null) : true) {
                if (selectedFile !== null) {
                    if (handleFileInput(selectedFile)) {
                        setUploadInProgress(true);
                        await envDocumentGetUrl('Bulk/uploadPayload/nuevo', selectedTemplateType, selectedFile.name).then(async (responseGetUrl) => {
                            if (responseGetUrl.data.succeeded === true) {
                                await envBlobDocumentUpload(responseGetUrl.data.data.url, responseGetUrl.data.data.fileName, selectedFile).then(async (responseAzure) => {
                                    if (responseAzure.data === "" && responseAzure.status === 201) {
                                        await envDocumentValidate(responseGetUrl.data.data.document_id).then(async (responseValidate) => {
                                            if (responseValidate.data.succeeded === true) {
                                                if (responseValidate.data.data.result_validate === true) {
                                                    setDocumentId(responseGetUrl.data.data.document_id)
                                                    setFileUploaded(true);
                            
                                                    const bulkProcessFileService = getProcessFileServiceEvent(selectedTemplateType);
                            
                                                    if (bulkProcessFileService !== null) {
                                                        if (responseGetUrl.data.data.document_id !== null) {
                                                            await bulkProcessFileService(responseGetUrl.data.data.document_id, queryStringElementId).then(async (serviceResponseProcess) => {
                                                                if (serviceResponseProcess.data.succeeded) {
                                                                    if (serviceResponseProcess.data.data.result) {
                                                                        setSelectedFile(null)
                                                                        fileInputRef.current.value = '';
                                                                        setDocumentId(null)
                                                                        setProcessedFile(null);
                                                                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))    
                                                                    }
                                                                    else {
                                                                        if (serviceResponseProcess.data.data.l_result_validation.length > 0) {
                                                                            setProcessedFile(serviceResponseProcess.data.data.l_result_validation[0]);
                                                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-templateerror'))
                                                                        }
                                                                        else {
                                                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                        }
                                                                    }
                                                                    setUploadInProgress(false);
                                                                    setFileUploaded(false)
                                                                }
                                                                else {
                                                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                    setUploadInProgress(false);
                                                                    setFileUploaded(false)
                                                                }
                                                            }).catch((error) => {
                                                                if (error.response) {
                                                                    const statusCode = error.response.status;
                                                                    
                                                                    if (statusCode === 504) {
                                                                        console.log('Error 504: Gateway Timeout - El servidor no respondió a tiempo');
                                                                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-operationerror-bulkuploadtimeout'))
                                                                    } else if (statusCode === 499) {
                                                                        console.log('Error 499: Client Closed Request - El cliente cerró la conexión antes de la respuesta');
                                                                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-operationerror-bulkuploadtimeout'))
                                                                    } else {
                                                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                    }
                                                                } else if (error.request) {
                                                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                } else {
                                                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                                }
                                            
                                                                setUploadInProgress(false);
                                                                setFileUploaded(false)
                                                            });
                                                        }
                                                        else {
                                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-completeprevsteps'))
                                                            setUploadInProgress(false);
                                                        }
                                                    }
                                                    else {
                                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                                        setUploadInProgress(false);
                                                    }
                                                    setUploadInProgress(false);
                                                }
                                                else {
                                                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.data.result_validate_msg))
                                                    setUploadInProgress(false);
                                                }
                                            }
                                            else {
                                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseValidate.data.message))
                                                setUploadInProgress(false);
                                            }
                                        })
                                        .catch((error) => {
                                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                            setUploadInProgress(false);
                                        });
                                    }
                                    else {
                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                        setUploadInProgress(false);
                                    }
                                })
                                .catch(async (error) => {
                                    await envDocumentValidate(responseGetUrl.data.data.document_id, 0).then(async () => {
                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                        setUploadInProgress(false);
                                    })
                                    .catch((error) => {
                                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                                        setUploadInProgress(false);
                                    });
                                });
                            } else {
                                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(responseGetUrl.data.message))
                                setUploadInProgress(false);
                            }
                            setSelectedFile(null);
                            setUploadInProgress(false);
                        })
                        .catch(() => {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                            setUploadInProgress(false);
                        });
                    }
                    else {
                        if (!selectedFile.name.endsWith('.xlsx') && !selectedFile.endsWith('.xls')) {
                            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-documentoperationerror-1')) 
                        }
                        else {
                            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-filesizeerror'))
                        }
                    }
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectfile'))
                    setUploadInProgress(false);
                }
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selectcontract'))
                setUploadInProgress(false);
            }
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-selecttemplate'))
            setUploadInProgress(false);
        }
    };

    const getProcessFileServiceEvent = (payloadId) => {
        switch (payloadId) {
            case enum__BULK_PAYLOAD_TYPE_ID.KPI:
                return postValidateKPIDocument;
            case enum__BULK_PAYLOAD_TYPE_ID.PARTIES:
                return postValidatePartidaDocument;
            case enum__BULK_PAYLOAD_TYPE_ID.BOOK:
                return postValidateBookDocument;
            default:
                return null
        }
    }

    const downloadErrorFile = () => {
        const byteCharacters = atob(processedFile);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Payload ${selectedTemplateType === enum__BULK_PAYLOAD_TYPE_ID.PARTIES ? "Partidas" : "KPI"} ${moment().format("YYYYMMDD")} Processed File.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'checkbox':
                editor.jqxCheckBox({ checked: (cellValue === 1 || cellValue === '1' || cellValue === 'True' || cellValue === 'true'), width: width });
                break;
            default:
                break;
        }
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };

    const getColumns = () => {
        let basicColumns = null;

            basicColumns = [
                { index: null, text: 'ID',                           dataField: 'key',         uploadMasive: false, exportable: false, width: '0px',   editable: false, hidden: true },
                { index: null, text: t('data-lang-lbl-enabled'),     dataField: 'checked',     uploadMasive: false, exportable: false, width: '10%', pinned: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'), columntype: 'checkbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: true },
                { index: 0,    text: t('data-lang-lbl-code'),        dataField: 'code',        uploadMasive: true,  exportable: true,  width: '15%', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: false, pinned: true },
                { index: 1,    text: t('data-lang-lbl-name'),        dataField: 'name',        uploadMasive: true,  exportable: true,  width: '25%', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: false, pinned: true },
                { index: 2,    text: t('data-lang-lbl-description'), dataField: 'description', uploadMasive: true,  exportable: true,  width: '50%', editable: false },
            ];

        return basicColumns;
    };

    const manipulateList = (list) => {
        list.unshift({key: -1, text: t('data-lang-lbl-select')})

        return list;
    };

    const onChangeSelectedTemplate = (event, option) => {
        setSelectedTemplateType(option.key)
    };

    /*const onChangeSelectedContract = (event, option) => {
        setSelectedContractElementId(option.key)
    };*/

    return (
        <>
            <AuthVerify currentToken={currentAuth} />
            {
                profileHasAccess &&
                <div className="col-12 listWithActions h-100">
                    <div className={inputParam_EditMode ? "card h-100" : "h-100"}>
                        <Card.Header>
                            <Card.Title className="d-flex justify-content-between">
                                <h4><b>{t('data-lang-maintainer-title-bulkupload')}</b></h4>
                                <TeachBubbleMultiSteps
                                    inputParam_ButtonId={"btnHelpBulk"}
                                    inputParam_Title={t('data-lang-helptext-title')}
                                    inputParam_ClassName="my-auto"
                                    inputParam_ButtonClassName="pb-2"
                                    inputParam_DirectionalHint={DirectionalHint.topCenter}
                                    inputParam_Steps={__enum_TeachBulkUpload.map(x => {return t(x)})}
                                    inputParam_NextTechStepType={"BulkUpload"}
                                />
                            </Card.Title>
                        </Card.Header>
                        <Card.Footer>
                            <MessageBox
                                inputParam_Message={ messageConfig.message }
                                inputParam_Display={ messageConfig.showMessage }
                                inputParam_MessageType={ messageConfig.messageType }
                                inputParam_SetterMessage={ setMessageConfig }
                                inputParam_MessageLink={processedFile !== null ? "Link" : null}
                                inputParam_MessageLinkFunction={processedFile !== null ? () => downloadErrorFile() : null}
                            />
                        </Card.Footer>
                        <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                            {
                                contract &&
                                <Row>
                                    <Col>
                                        <IndexHeaderBulkpUpload inputParam_Contract={contract} />
                                    </Col>
                                </Row>
                            }
                            <div className="align-items-center h-100">
                                <div className="d-none">
                                    <TooltipHost content={
                                        <>
                                            <div>{'Tool TIP Archivos Permitidos: "7z", "doc", "docx", "eml", "jpeg", "jpg", "msg", "ods", "pdf", "png", "ppt", "pptx", "rar", "txt", "xls", "xlsb", "xlsx", "xps", "zip“. Peso: 80mb.'}</div>
                                            <div>{'Si tiene problemas con estos formatos, sugerimos guardar nuevamente el archivo con un programa estándar, ejemplo: Archivo de imagen “.jpg”  o “.png” utilizar abrir en “Paint” y volver a guardar.'}</div>
                                        </>
                                    }>
                                        <input ref={fileInputRef} type="file" accept=".xlsx" onChange={handleFileInput} />
                                    </TooltipHost>
                                </div>
                                {
                                    listBulkTemplates &&
                                    <>
                                        <div className="d-flex justify-content-end">
                                            <div className="d-flex pt-2">
                                                <CLabel labelText={t('data-lang-lbl-templatetype')} />
                                                <Dropdown
                                                    placeholder={t('data-lang-btn-select')}
                                                    options={manipulateList(__BULK_PAYLOAD_TYPE_ID
                                                        .filter(item => contextSite.securityProps.l_products.some(product => product.toLowerCase() === item.keyTypeUniqueId.toLowerCase()))
                                                        .filter(x => isNullUndefinedOrEmpty(queryStringElementId)? x.enabledOnlyWithElementIdAvailable === false : true)
                                                        .map(x => {return {key: x.key, text: t(x.text)}}))}
                                                    selectedKey={selectedTemplateType}
                                                    onChange={onChangeSelectedTemplate}
                                                    checkable
                                                    disabled={false}
                                                    style={{width: "150px"}}
                                                    styles={ {title: { height: "27px" }} }
                                                    className="mb-1"
                                                />
                                            </div>
                                            <div className="px-1"><ActionButton id="btnGetTemplate" iconProps={{iconName: "Download"}} text={t('data-lang-btn-bulk-gettemplate')} onClick={handlerExportTemplate} /></div>
                                            {
                                                uploadInProgress &&
                                                <div className="px-1">
                                                    <Loading
                                                            inputParam_ShowLoading={true}
                                                            inputParam_ShowText={false}
                                                            inputParam_Width={'35px'}
                                                            inputParam_Height={'35px'}
                                                            inputParam_Left={""}
                                                            inputParam_Style={{marginTop: 0}}
                                                            inputParam_ColClassName={"me-2"}
                                                            inputParam_MarginLeft={"auto"}
                                                            inputParam_SpinnerSize={SpinnerSize.medium} />
                                                </div>
                                            }
                                            {
                                                !uploadInProgress &&
                                                <>
                                                    <div className="px-1">
                                                        <ActionButton 
                                                            id="btnSelectFile"
                                                            styles={{root: {color: (selectedFile !== null ? "green" : undefined)}}} 
                                                            iconProps={{iconName: (selectedFile !== null ? (fileUploaded ? "Attach" : "SkypeCircleCheck") : "Attach")}}
                                                            text={selectedFile !== null ? (fileUploaded ? t('data-lang-btn-bulk-attachtemplate') : selectedFile.name) : t('data-lang-btn-bulk-attachtemplate')} 
                                                            onClick={handlerSelectFile} />
                                                    </div>
                                                    <div className="px-1"><ActionButton id="btnUploadFile" iconProps={{iconName: "Upload"}} text={t('data-lang-btn-bulk-uploadandprocesstemplate')} onClick={handlerUploadFile} /></div>
                                                </>
                                            }
                                        </div>
                                        <div id={inputParam_ShowSelection ? "gridConfigElement" : undefined}>
                                            <JqxGrid
                                                ref={gridRef}
                                                altrows={false}
                                                enabletooltips={true}
                                                width={'100%'}
                                                height={"550px"}
                                                theme={'light'} 
                                                editable={false}
                                                pageable={ false }
                                                sortable={true}
                                                filterable={true}
                                                showfilterrow={true} 
                                                localization={getGridLocalization(t)}
                                                source={ new jqx.dataAdapter({
                                                    localData: listBulkTemplates,
                                                    dataType: 'array',
                                                    dataFields: [
                                                        { name: 'key',                   type: 'number' },
                                                        { name: 'code',                  type: 'string' },
                                                        { name: 'name',                  type: 'string' },
                                                        { name: 'description',           type: 'string' },
                                                        { name: 'checked',               type: 'bool' },
                                                    ],
                                                    id: 'key'
                                                })}
                                                columns={getColumns()}
                                            />
                                        </div>
                                    </>
                                }
                            </div>
                        </Card.Body>
                    </div>           
                </div>
            }
            {
                !profileHasAccess &&
                <div className="col-12 listWithActions h-100">
                    <Card className="h-100">
                        <div>{t('data-lang-msg-accessdenied')}</div>
                    </Card>
                </div>
            }
        </>
    ); 
}